@if (licenses().length === 0) {
  <div class="p-3 text-center text-500">
    <fa-icon [icon]="['fas', 'info-circle']" class="mb-2"></fa-icon>
    <p class="text-sm mb-0">No processed licenses to display</p>
  </div>
} @else {
  <div class="flex flex-column gap-2">
    @for (license of licenses(); track license.id) {
      <div class="p-2 surface-100 border-round">
        <!-- Compact header: License number + badges + actions -->
        <div class="flex justify-content-between align-items-center gap-2 mb-1">
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-sm truncate">{{ license.licenseNumber }}</div>
            <div class="text-xs text-600 truncate">
              {{ license.coaterName }}
              @if (license.glAbbreviation || license.glName) {
                <span class="text-400 ml-1">({{ license.glAbbreviation || license.glName }})</span>
              }
            </div>
          </div>

          <div class="flex gap-1 align-items-center flex-shrink-0">
            <!-- Certificate status badge -->
            <p-tag
              [value]="certificateStatusLabel(license)"
              [severity]="certificateStatusSeverity(license)"
              [pTooltip]="license.certificateError || ''"
              [tooltipDisabled]="!license.certificateError"
              tooltipPosition="top"
              styleClass="text-xs mr-2">
              @if (license.certificateStatus === 'Processing' || (license.certificateStatus === 'Pending' && isRefreshing())) {
                <fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" size="xs" class="mr-1"></fa-icon>
              }
            </p-tag>

            <!-- GL status icon only (hide if send/retry buttons will be shown) -->
            @if (!showGlSend(license) && !showGlRetry(license)) {
              <fa-icon
                [icon]="glStatusIcon(license)"
                [pTooltip]="glStatusTooltip(license)"
                tooltipPosition="top"
                [style.color]="glStatusColor(license)"
                class="ml-1">
              </fa-icon>
            }

            <!-- Send GL notification button (for skipped/not sent) -->
            @if (showGlSend(license)) {
              <p-button
                icon="pi pi-send"
                severity="info"
                [text]="true"
                [rounded]="true"
                size="small"
                class="gl-action-btn"
                (onClick)="onRetryGlNotification(license)"
                [pTooltip]="getSendGlTooltip(license)"
                tooltipPosition="top">
              </p-button>
            }

            <!-- Retry GL button -->
            @if (showGlRetry(license)) {
              <p-button
                icon="pi pi-send"
                severity="warn"
                [text]="true"
                [rounded]="true"
                size="small"
                class="gl-action-btn"
                (onClick)="onRetryGlNotification(license)"
                pTooltip="Retry GL notification"
                tooltipPosition="top">
              </p-button>
            }

            <!-- View certificate button -->
            @if (showCertificateDownload(license)) {
              <p-button
                icon="pi pi-eye"
                severity="secondary"
                [text]="true"
                [rounded]="true"
                size="small"
                (onClick)="onViewCertificate(license)"
                pTooltip="View certificate"
                tooltipPosition="top">
              </p-button>
            }

            <!-- Retry certificate button -->
            @if (showCertificateRetry(license)) {
              <p-button
                icon="pi pi-refresh"
                severity="warn"
                [text]="true"
                [rounded]="true"
                size="small"
                (onClick)="onRetryCertificate(license)"
                pTooltip="Retry certificate generation"
                tooltipPosition="top">
              </p-button>
            }
          </div>
        </div>

        <!-- Compact expiry info -->
        <div class="text-xs text-600">
          <fa-icon [icon]="['fas', 'calendar']" size="xs" class="mr-1"></fa-icon>
          {{ license.currentExpiryDate | date: 'shortDate':'UTC' }}
          <fa-icon [icon]="['fas', 'arrow-right']" size="xs" class="mx-1"></fa-icon>
          {{ license.newExpiryDate | date: 'shortDate':'UTC' }}
          @if (showGlInfo(license)) {
            <span class="ml-2">
              <fa-icon [icon]="['fas', 'envelope']" size="xs" class="mr-1"></fa-icon>
              {{ license.glRecipientEmail }}
            </span>
          }
        </div>
      </div>
    }
  </div>
}
